export default __webpack_public_path__ + "static/media/submitted.f5f5686a.svg";